export const hasVideoContentType = (contentType?: string): boolean => {
  return /(^video)(\/)[a-zA-Z0-9_]*/gm.test(contentType ?? '');
};
